import React, { useState } from 'react'

export default function ProjectEmbed(props) {


    return (
        <div className='project-embed'>
            <div className='banner'>
                12.38 TYPOGRAPHIC MUSIC VIDEO
            </div>
            <div className='box-1'>
                <iframe className="frame" width="100%" height="100%" src={props.link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div className='box-2'>
                Softwares Used: AE, AI, PS <br /> <br />
                This is a typographic music video to rapper 21 Savage’s verse on the song ’12.38’ by Childish Gambino. Released at the beginning of the first lockdown in 2020, this song quickly became my most listened to song of the year. The song’s funky beat and the stylish flow of the two rappers made it certain that I would use this song for my Motion Graphics typography project. The assets and storyboard were made using Photoshop and Illustrator and the entirety of the animation was done in After Effects. This by far remains one of my favorite projects and is why I enjoy animating music and typography.
            </div>
        </div>
    )
}
